module.exports = __webpack_public_path__ + "img/filter.7e463261.svg";